export default __webpack_public_path__ + "static/media/undraw_preferences_re_49in.7ffdf33b.svg";